angular.module("app").factory("settingsService", [
    'preLoadedData',
    'stateAliases',
    function (preLoadedData, stateAliases) {
        var info = {};

        if (!!preLoadedData.data && preLoadedData.data.status == "ok") {
            setSettings(preLoadedData.data);
        }

        function  setSettings (settings) {
            var allSettings = angular.copy(settings);
            delete allSettings.userInfo;
            info.settings = angular.copy(allSettings);
            info.settings.menuVisibleStates && stateAliases.setStates(info.settings.menuVisibleStates, registerState)
        }

        function getSettings () {
            return info.settings;
        }

        function reset () {
            if (!!info.settings) {
                for (var prop in info.settings) {
                    info.settings[prop] = undefined;
                }
            }
        }

        function registerState (state) {
            if (info.settings) {
                info.settings.allowedStates = info.settings.allowedStates || [];
                info.settings.allowedStates.push(state)
            }
        }

        function getAllowedStates () {
            if (info.settings && info.settings.allowedStates) {
                return info.settings.allowedStates;
            }
        }

        function getPreferredState () {
            return function (state) {
                var allowedStates = getAllowedStates();
                if (allowedStates && allowedStates.length) {
                    if (allowedStates.indexOf(state) != -1) {
                        return state
                    } else {
                        return allowedStates[0]
                    }
                } else {
                    return "login"
                }
            }
        }

        return {
            setSettings: setSettings,
            getSettings: getSettings,
            registerState: registerState,
            getPreferredState: getPreferredState,
            getAllowedStates: getAllowedStates,
            reset: reset
        }
    }
]);